import {
  DemostackLabelIllustration,
  MarkOrangeIllustration,
} from '@carboncopyco/illustrations';
import { ProgressBar, TextCaption } from '@carboncopyco/ui';
import { useEffect, useState } from 'react';
import { LINK_RELEASE_NOTES } from '../../../shared/constants/constants';
import { AppEventsEnum } from '../../../shared/enums/AppEventsEnum';

const InstallUpdatesModal = () => {
  const [percentage, setPercentage] = useState<number>(0);
  const [updateInfo, setUpdateInfo] = useState<{
    appVersion: string;
  } | null>(null);

  useEffect(() => {
    window.dsDesktop?.ipcRenderer.on(
      AppEventsEnum.INSTALL_UPDATES,
      (appData: any) => {
        setPercentage(appData.percentage);
        setUpdateInfo({
          appVersion: appData.appVersion,
        });
      }
    );
  }, []);

  const ModalHeader = () => (
    <>
      <MarkOrangeIllustration />
      <div className="pt-3">
        <DemostackLabelIllustration />
      </div>
      <div className="mt-7">
        <p className="text-[16px] text-ds-natural-600">{`New update available: ${updateInfo?.appVersion}`}</p>
      </div>
      <div
        onClick={() => {
          window.dsDesktop.shellOpenExternal(LINK_RELEASE_NOTES);
        }}
        className="cursor-pointer"
      >
        <TextCaption
          label="View release notes"
          color="text-ds-natural-600"
          underline
        />
      </div>
    </>
  );

  const ModalContent = () => (
    <div className="w-52 mt-20">
      <ProgressBar
        value={percentage}
        maxValue={100}
        label="Installing updates..."
        showValueText={false}
        progressColor="bg-ds-natural-300"
      />
    </div>
  );

  return (
    <div className="flex flex-col align-center justify-center py-3 bg-ds-natural-50 h-[357px]">
      <ModalHeader />
      <ModalContent />
    </div>
  );
};

export default InstallUpdatesModal;
